import React from 'react';
import SystemDetail from './SystemDetail';

export default (props) => {
    //TODO: Split up and allow for multiple systems
    return <SystemDetail />
}